export default __webpack_public_path__ + "static/client4-29073cf8e82c3e6b42d33056cec64317.png";